import { motion } from "framer-motion";

const ITEMS = [
    "Premium business websites",
    "Lead generation systems",
    "Reputation infrastructure",
    "Google Business Profile",
    "Editorial content systems",
    "Conversion-grade landing pages",
];

export const CredibilityStrip = ({ variant = "light" }) => {
    const isDark = variant === "dark";
    return (
        <section
            data-testid="credibility-strip"
            className={`${
                isDark
                    ? "bg-[#111111] text-white border-y border-white/15"
                    : "bg-white text-[#111111] border-y border-[#dddddd]"
            }`}
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-7 md:py-9">
                <div className="grid grid-cols-1 md:grid-cols-12 items-center gap-6">
                    <div className="md:col-span-3 flex items-center gap-3">
                        <span
                            className={`w-2 h-2 rounded-full ${
                                isDark ? "bg-white" : "bg-[#111111]"
                            }`}
                        />
                        <span className="text-[10px] tracking-[0.28em] uppercase opacity-70">
                            Trusted across
                        </span>
                    </div>
                    <ul className="md:col-span-9 flex flex-wrap items-center gap-x-6 gap-y-3 md:justify-end">
                        {ITEMS.map((t, i) => (
                            <motion.li
                                key={t}
                                initial={{ opacity: 0, y: 8 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{
                                    duration: 0.6,
                                    delay: i * 0.05,
                                    ease: [0.16, 1, 0.3, 1],
                                }}
                                className="flex items-center gap-2 font-serif italic text-base md:text-lg"
                            >
                                {t}
                                {i < ITEMS.length - 1 && (
                                    <span aria-hidden className="opacity-30 not-italic">
                                        ✻
                                    </span>
                                )}
                            </motion.li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
};
